<h2 mat-dialog-title>{{fieldForm.value.title ?? fieldTitle}}</h2>

<mat-dialog-content>
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
      <form [formGroup]="fieldForm">

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'taskTemplates.wt_title' | translate}}</mat-label>
          <input matInput name="title" formControlName="title" class="form-control" placeholder="{{'taskTemplates.wt_title' | translate}}"  type="text" data-nar="form-widget-field-title">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100 mb-3">
          <mat-label>{{'taskTemplates.key' | translate}}</mat-label>
          <input matInput name="key" formControlName="key" class="form-control" [errorStateMatcher]="matcher" placeholder="{{'taskTemplates.key' | translate}}" id="key" type="text" required>
          @if (fieldForm.get('key')?.errors?.['pattern']) {
            <mat-error> {{'invalid_characters' | translate}} </mat-error>
          }
          @if (fieldForm.get('key')?.errors?.['required']) {
            <mat-error> {{'required' | translate}} </mat-error>
          }
          @if (!fieldForm.controls['key']?.errors) {
            <mat-hint >{{'taskTemplates.valid-safe-key' | translate}}</mat-hint>
          }
        </mat-form-field>

        <div class="form-control p-3 mb-3  d-flex justify-content-between">
          <label for="title" >{{'taskTemplates.mandatory' | translate}}</label>
          <mat-slide-toggle formControlName="mandatory" data-nar="form-widget-field-required"></mat-slide-toggle>
        </div>

        @if (fieldForm.value.type=='boolean') {
          <div class="form-control p-3 mb-3  d-flex justify-content-between">
            <label for="title" >{{'taskTemplates.showValueAsLabel' | translate}}</label>
            <mat-slide-toggle formControlName="showValueAsLabel" data-nar="form-widget-field-required"></mat-slide-toggle>
          </div>
          <div class="boolean-label-hint mb-3">
            <small>{{'taskTemplates.showValueAsLabelHint' | translate}}</small>
          </div>

          @if (fieldForm.value.showValueAsLabel) {
            <div id="toolbar">
              <div class="d-flex justify-content-between">
                <div class="ql-default-buttons">
                  <button class="ql-bold" matTooltip="{{'pass.bold' | translate}}"></button>
                  <button class="ql-italic" matTooltip="{{'pass.italic' | translate}}"></button>
                  <button class="ql-link" matTooltip="{{'pass.link-URL' | translate}}"></button>
                  <button class="ql-clean" matTooltip="{{'pass.clean' | translate}}"></button>
                </div>

              </div>
            </div>
      
            <!-- Quill Editor -->
            <quill-editor
              #editor
              formControlName="value"
              class="mb-4 w-100"
              [ngClass]="getLanguageClass()"
              id="text"
              [modules]="quillModules"
              placeholder="{{'insertText' | translate}}"
              [styles]="{ height: '200px', width: '100%' }"
              (onEditorCreated)="onEditorCreated($event)">
            </quill-editor>
          }
        }

        @if (fieldForm.value.type=='options') {
          <div>
            <div class="m-1">
              <div class="text-muted">{{'taskTemplates.OPTIONS' | translate}}</div>
              <button mat-button
                class="secondary-gray-button my-3"
                id="btn-add"
                (click)="addNewOptionToField();" data-nar="form-widget-add-option" [disabled]="disableFields"
                >
                <mat-icon>add_circle</mat-icon> {{'add' | translate}}
              </button>
              <mat-list role="list" class="list-group">
                @for (option of fieldForm.value.options; track option.id ?? option.value ?? option; let index = $index) {
                  <mat-list-item role="listitem" style="color:var(--warmOrange); cursor:pointer;" class="list-group-item" (click)="editOptionToField(option, index);" >
                    <div class="d-flex flex-row justify-content-between align-items-center">
                      <span style="color:var(--warmOrange);"> {{option?.title ? option.title : (option?.value ? option.value : option )}}</span>
                      <button mat-icon-button (click)="deleteOption(option, index);"  >
                        <span class="material-symbols-outlined" style="color: var(--accentGlobal);">
                          delete
                        </span>
                      </button>
                    </div>
                  </mat-list-item>
                }
              </mat-list>
            </div>
          </div>
        }

        @if (fieldForm.value.type=='map') {
          <div>
            <div class="form-control p-3 mb-3  d-flex justify-content-between">
              <label for="title" >{{'taskTemplates.showsAccuracy' | translate}}</label>
              <mat-slide-toggle formControlName="showsAccuracy" ></mat-slide-toggle>
            </div>
            <div class="form-control p-3 mb-3  d-flex justify-content-between">
              <label for="title" >{{'taskTemplates.selectLocation' | translate}}</label>
              <mat-slide-toggle formControlName="selectLocation" ></mat-slide-toggle>
            </div>
            <div class="form-control p-3 mb-3  d-flex justify-content-between">
              <label for="title" >{{'taskTemplates.gpsLocation' | translate}}</label>
              <mat-slide-toggle formControlName="gpsLocation" ></mat-slide-toggle>
            </div>
            <div class="form-control p-3 mb-3  d-flex justify-content-between">
              <label for="title" >{{'taskTemplates.showsMap' | translate}}</label>
              <mat-slide-toggle formControlName="showsMap" ></mat-slide-toggle>
            </div>
          </div>
        }

        @if(enableValidations){
          <div [app-work-task-template-field-rules] = "fieldForm.value" (returnChanges)="returnChangesFieldRules($event)"></div>
        }

      </form>
    </section>
  </div>
</mat-dialog-content>


<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="onCancel();" >
    {{'cancel' | translate}}
  </button>
  <button mat-button class="orange-button" (click)="onSave();" [disabled]="fieldForm.invalid">{{'apply' | translate}}</button>
</mat-dialog-actions>
